import { chooseReducer } from '@/utils/draftHelper';
import initialState from './state';
import updateDatasetCollectionsState from './datasetCollections';
import updateDatasetSettingsState from './datasetSettings';
import updateDatasetState from './dataset';
import updateCollectionState from './collection';
import updateCollectionsState from './collections';

const handlers = {
  ...updateDatasetCollectionsState,
  ...updateDatasetSettingsState,
  ...updateDatasetState,
  ...updateCollectionState,
  ...updateCollectionsState,
};

export default (state = initialState, action) => chooseReducer(state, action, handlers);
